<template>
    <card>
        <h5 slot="header" class="title">Automatic Payments</h5>
        <base-button type="info" @click="connectMollie" :disabled="mollie.hasValidMandate" :loading="loading">Setup
            Automatic
            payments
        </base-button>
        <br>
        <small class="info info-horizontal ">
            This button will redirect you to a payment form where a small payment of € 0,01 will be made. This will
            create a Mandate which we can use to automatically charge your account/card for future invoices.
        </small>
    </card>
</template>
<script>
    import {mapFields} from 'vuex-map-fields';

    export default {
        data() {
            return {
                loading: false,
            }
        },
        computed: {
            ...mapFields('customer', ['mollie'])
        },
        methods: {
            connectMollie() {
                this.loading = true;
                this.$store.dispatch('customer/connectMollie', {url: window.location.href}).then(resp => {
                    window.location = resp.url;
                }).catch(() => {
                    this.$notify({
                        position: "bottom-right",
                        message: 'Failed to connect, try again later.',
                        type: "error",
                        iconClass: "fal fa-times",
                        title: "Error!"
                    });
                }).finally(() => {
                    this.loading = false;
                });
            },
        },
        mounted() {
            this.loading = true;
            this.$store.dispatch('customer/loadMollie').finally(() => {
                this.loading = false
            });
        }
    };
</script>
<style></style>
